module.exports = __webpack_public_path__ + "img/F_05.eb41d72d.gif";